import React from "react";
import IsInStock from "./IsInStock";
import { calculateDisplayedPrice } from "../../utils/calculateDisplayedPrice";

export default function PriceOfferChildNoDsicount(props) {
  // PROPS COMING FROM TimeRestrictedPriceOffer
  const { product, price } = props;

  return (
    <table style={{ width: "90%" }}>
      <tbody>
        <tr>
          <td>
            <div className="row w95p fs125 txtcenter padq">
              <div className="w70p row">
                <p className="w90p">
                  {calculateDisplayedPrice(price.price)} TL
                </p>
              </div>
              <div className="w30p txtright">
                <IsInStock product={product} />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
